import React, {FC, useEffect, useState} from "react"

import {Deal} from "@irati/types"
import {FormattedMessage} from "@irati/utils/lang"
import Flex from "@irati/ui/src/Flex"
import {Body} from "@irati/ui/src/Typography"
import isWalletBalanceApplicable from "@irati/deals/helpers/isWalletBalanceApplicable"
import isZipEnabled from "@irati/deals/helpers/deals/isZipEnabled"
import mastercardLogo from "@irati-web/payments/src/images/mastercard.svg"
import visaLogo from "@irati-web/payments/src/images/visa.svg"
import zipLogo2 from "@irati-web/payments/src/images/zip_logo.svg"
import {ZipImage} from "@irati-web/payments/src/components/ZipModal/styled"
import ZipReadMoreAndModal from "@irati-web/payments/src/components/ZipModal/ZipReadMoreAndModal"
import {isPayPalAvailable} from "@irati/utils/payment/isPayPalAvailable"
import getCurrencyForDeal from "@irati/deals/helpers/deals/currency"
import WalletBallance from "@irati/wallet/apollo/query/Wallet"
import authentication from "@irati/auth"
import {isPaymentRequired} from "@irati/deals/helpers/redemption/deal"
import withPerkOrReward, {WithPerkOrReward} from "@irati-web/flexi-rewards/src/utils/withPerkOrReward"

import {Image, PayPalLogo} from "./styled/ImportantInfoBlock"
import WalletSpendBalance from "./WalletSpendBalance"

interface Props extends WithPerkOrReward{
  deal: Deal
}

const CashDealType: FC<Props> = ({deal, isRewards}) => {
  if (!isPaymentRequired(deal) || deal.isTTDeal || isRewards) {
    return null
  }
  const [isWithPayPal, setIsWithPayPal] = useState<boolean>(false)
  const [paymentOptionsHeader, setPaymentOptionsHeader] = useState<string>("perks.dealInfo.importantInfo.noWalletBalance.payWith")
  const userId = authentication.user().uuid
  const hasCashWallet = authentication.apps("wallet.users")

  useEffect(() => {
    isPayPalAvailable(getCurrencyForDeal(deal)).then((value) => setIsWithPayPal(value))
  }, [])

  return (
    <>
      {hasCashWallet && (
        <WalletBallance variables={{userId, currency: getCurrencyForDeal(deal)}} useLoader={false}>
          {({data}) => {
            const wallet = data!.wallet
            const hasWalletBalance = isWalletBalanceApplicable(deal, wallet)
            if (!hasWalletBalance) {return null}
            setPaymentOptionsHeader("perks.dealInfo.importantInfo.walletBalance.youCanAlsoPayWith")

            return <WalletSpendBalance wallet={wallet} />
          }}
        </WalletBallance>
      )}

      <section>
        <Flex direction="row" justifyContent="center" alignContent="center">
          <Body><FormattedMessage id={paymentOptionsHeader} /></Body>
        </Flex>
        <Flex justifyContent="center" alignContent="center" marginBottom={1}>
          <Image src={mastercardLogo} />
          <Image src={visaLogo} />
          {isWithPayPal && <PayPalLogo />}
        </Flex>
        {isZipEnabled(deal) && (
          <Flex justifyContent="center" alignContent="center" marginBottom={2}>
            <ZipImage src={zipLogo2} />
            <Flex marginLeft={1}>
              <ZipReadMoreAndModal />
            </Flex>
          </Flex>
        )}
      </section>
    </>
  )
}

export default withPerkOrReward(CashDealType)
